<section class="patient-bills">
  <div class="patient-bills-header">
    <div class="patient-bills-actions">
      <button
        mat-stroked-button
        type="button"
        appGuideAnchor="patient-register-payment"
        [disabled]="refreshing() || !patientId() || !patientName().trim()"
        (click)="openPayment()"
      >
        Registrar pago
      </button>
      <button
        mat-stroked-button
        type="button"
        appGuideAnchor="patient-new-bill"
        [disabled]="refreshing() || !patientId() || !patientName().trim()"
        (click)="openCreate()"
      >
        Nuevo Cobro
      </button>
    </div>
  </div>

  @if (loading()) {
    <div class="patient-bills-loading" role="status" aria-label="Cargando cuenta">
      <mat-spinner diameter="32"></mat-spinner>
    </div>
  } @else {
    <div
      #accountBody
      class="patient-bills-body"
      [class.is-refreshing]="refreshing()"
      [style.min-height.px]="lockedHeight()"
    >
    <div class="patient-balance">
      <div>
        <span class="patient-balance-label">Cobrado</span>
        <span class="patient-balance-value">{{ formatMoney(account().billed) }}</span>
      </div>
      <div>
        <span class="patient-balance-label">Pagado</span>
        <span class="patient-balance-value">{{ formatMoney(account().paid) }}</span>
      </div>
      <div [class.patient-balance-pending]="account().difference > 0" [class.patient-balance-credit]="account().difference < 0">
        <span class="patient-balance-label">{{ balanceLabel() }}</span>
        <span class="patient-balance-value">{{ formatMoney(account().difference < 0 ? -account().difference : account().difference) }}</span>
      </div>
    </div>

    <h4>Cobros</h4>
    @if (bills().length === 0) {
      <p class="patient-bills-hint">No hay cobros todavía.</p>
    } @else {
      <ul class="patient-bills-list">
        @for (bill of bills(); track bill.id) {
          <li>
            <div class="patient-bill-main">
              <span class="patient-bill-due">Vence {{ formatDueDate(bill.dueDate) }}</span>
              <span class="patient-bill-doctor">{{ bill.doctorName }}</span>
              <span class="patient-bill-items">{{ itemSummary(bill) }}</span>
            </div>
            <span class="patient-bill-total">{{ formatMoney(total(bill.items)) }}</span>
            @if (canDelete(bill)) {
              <button mat-icon-button type="button" aria-label="Eliminar cobro" (click)="remove(bill)">
                <mat-icon>delete</mat-icon>
              </button>
            }
          </li>
        }
      </ul>
    }

    <h4>Pagos</h4>
    @if (payments().length === 0) {
      <p class="patient-bills-hint">No hay pagos todavía.</p>
    } @else {
      <ul class="patient-bills-list">
        @for (payment of payments(); track payment.id) {
          <li>
            <div class="patient-bill-main">
              <span class="patient-bill-due">{{ formatDueDate(payment.paidOn) }}</span>
              @if (payment.registeredByName) {
                <span class="patient-bill-doctor">Registrado por {{ payment.registeredByName }}</span>
              }
            </div>
            <span class="patient-bill-total">{{ formatMoney(payment.amount) }}</span>
            <button mat-icon-button type="button" aria-label="Eliminar pago" (click)="removePayment(payment)">
              <mat-icon>delete</mat-icon>
            </button>
          </li>
        }
      </ul>
    }
    @if (refreshing()) {
      <div class="patient-bills-overlay" role="status" aria-label="Actualizando cuenta">
        <mat-spinner diameter="32"></mat-spinner>
      </div>
    }
    </div>
  }
</section>
